
import React, {Component} from 'react';
import './style.css';
import ImageProduct from "./ImageProduct/ImageProduct";


class FullProduct extends Component {
    constructor(props) {
        super(props);
        this.state = {
            counter: 0
        }
    }

    decNumber = () => {
        if (this.state.counter < 1){
            this.setState(
                {counter: this.state.counter = 0}
            )
        } else {
            this.setState(
                {
                    counter: this.state.counter - 1
                }
            )
        }
    }

    incNumber = () => {
        this.setState({counter: this.state.counter + 1});
    }

    render() {
        return(
            <div className={"container"}>
                {/*<button type={"button"} onClick={this.decNumber}>Decrement</button>*/}
                {/*<span>{this.state.counter}</span>*/}
                {/*<button type={"button"} onClick={this.incNumber}>Increment</button>*/}

                <div className={"row"}>
                    <div className={"col"}>
                        <ImageProduct/>
                    </div>
                    <div className={"col col-product-info"}>
                        <p className={"product-name"}>NIKE AIR JORDAN 4 RETRO</p>
                        <p className={"product-status"}>Товар: <span className={"status"}>В наличии</span></p>
                        <p className={"product-price"}><span className={"current-price"}>555 000 сум</span>&nbsp;&nbsp;<span className={"old-price"}><del>925 000 сум</del></span></p>
                        <button className={"btn-counter"} onClick={this.decNumber}>-</button>
                            <span className={"product-count"}>{this.state.counter}</span>
                        <button className={"btn-counter"} onClick={this.incNumber}>+</button>
                        <button className={"btn-buy"} type={"button"}>Купить сейчас</button>
                        <button className={"btn-add-card"} type={"button"}>В корзину</button>
                        <button className={"btn-add-favorite"} type={"button"}>
                            <i className="fas fa-heart"/>
                        </button>
                        <p className={"product-info"}>
                            <ul className={"info-unordered"}>
                                <li>
                                    Вверх из искусственной кожи
                                </li>
                                <li>
                                    Высокая шнуровка обеспечивает надежную фиксацию
                                </li>
                                <li>
                                    Материал подошвы: Резина, филон
                                </li>
                                <li>
                                    Хорошие теплозащитные свойства
                                </li>
                                <li>
                                    Запоминающийся дизайн, удобная посадка и максимальный уровень комфорта
                                </li>
                                <li>
                                    Боковая сетка для отличной регуляции воздуха
                                </li>
                            </ul>
                        </p>
                        <p className={"info-make-order"}>
                            Как сделать заказ:
                            <ul className={"info-unordered"}>
                                <li>
                                    Добавляете товар в корзину и оформляете заказ;
                                </li>
                                <li>
                                    С вами связывается наш менеджер и сообщает о наличии размера на складе.
                                </li>
                            </ul>
                        </p>
                    </div>
                </div>
            </div>
        )
    }
}

export default FullProduct;